import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    actionButtons: {
        display: 'grid',
        flexDirection: 'row',
        rowGap: 12,
        columnGap: 12,
    },
    iconButton: {
        padding: 0,
        gridRow: 1,
        backgroundColor: 'black',
        color: 'white',
        width: '26px',
        height: '26px',
        borderRadius: '4px',
        '&:hover': {
            backgroundColor: '#95969B',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    iconButtonError: {
        padding: 0,
        gridRow: 1,
        backgroundColor: 'red',
        color: 'white',
        width: '26px',
        height: '26px',
        borderRadius: '4px',
        '&:hover': {
            backgroundColor: '#95969B',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    iconEdit: {
        backgroundColor: 'black',
    },
    tableHeaderSortIcon: {
        padding: 6,
        marginLeft: 5,
    },
    tableHeaderCell: {
        whiteSpace: 'nowrap',
    },
    tableRow: {
        verticalAlign: 'top',
    },
    wrapper: {
        width: '100%',
        marginTop: '10px',
        height: 'calc(100% - 70px)',
    },
    lastChildFixed: {
        '& th': {
            '&:last-child': {
                position: 'sticky',
                right: 0,
                zIndex: 3,
            },
        },

        '& td': {
            '&:last-child': {
                position: 'sticky',
                right: 0,
                backgroundColor: '#FFF',
                borderBottom: '2px solid #EEE',
            },
        },
    },
    container: {
        // maxHeight: 600,
        height: '100%',
        overflowY: 'auto',

        scrollbarWidth: 'thin',

        '&::-webkit-scrollbar': {
            width: 5,
            height: 5,
        },

        '&::-webkit-scrollbar-thumb': {
            background: '#d0d0d0',
            borderRadius: 7,
        },

        '& td, th': {
            padding: '7px 32px',

            [theme.breakpoints.down('md')]: {
                fontSize: '12px',
            },
        },
    },
}));
